import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

export const businessAreaNameColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
): TableColumn<T> => ({
  id: 'businessAreaName',
  label: <Trans i18nKey="business_area" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">{value}</div>
  ),
  acessorKey: 'businessAreaName',
  sortable: true,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
